/**
 * String utility functions to replace lodash
 */

import { parsePhoneNumberFromString, type CountryCode } from 'libphonenumber-js';

/**
 * Format a phone number for display (national format), same as client additional details.
 * Falls back to the raw value if parsing fails.
 */
export function formatPhoneNumberNational(value: string, defaultCountry: CountryCode = 'CA'): string {
  if (!value) {
    return value;
  }
  try {
    const phoneNumber = parsePhoneNumberFromString(value, defaultCountry);
    if (phoneNumber) {
      return phoneNumber.formatNational();
    }
    return value;
  } catch {
    return value;
  }
}

/**
 * Unescape HTML entities
 * Replaces: _.unescape(string)
 */
export function unescape(str: string): string {
  const htmlEntities: Record<string, string> = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#x27;': "'",
    '&#x2F;': '/',
  };
  
  return str.replace(/&[#\w]+;/g, (entity) => {
    return htmlEntities[entity] || entity;
  });
}
